import { makeStyles } from "@mui/styles";

const useAnswerStyle = makeStyles(() => ({
  headingMain: {
    width: "100%",
    "& .MuiTypography-h3": {
      color: "#223852",
      textAlign: "center",
      fontSize: "1rem",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "2.625rem",
      textTransform: "capitalize",
    },
  },
  divider: {
    width: "5%",
    textAlign: "center",
    margin: "0rem auto",
    height: "5px",
    background: "#4565B7",
    borderRadius: "6px",
  },
}));

export default useAnswerStyle;
